import { Box, Button, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { securityClient } from 'securityClient';
import { useAppDispatch } from 'State/hooks';
import { clearCompany } from 'State/companySlice';
import React from 'react';
import MenuButton from 'Components/MenuButton';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useSignoutMutation } from 'Services/auth';

const Topbar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const [signout] = useSignoutMutation();

    const userMenuItemClicked = async (setting: string) => {
        if (setting.toLowerCase() === 'logout') {
            try {
                await signout().unwrap();
            } catch (_) {
                // proceed with local logout even if API call fails
            }
            securityClient.clearToken();
            dispatch(clearCompany());
            localStorage.clear();
            sessionStorage.clear();
            navigate('/login');
        } else if (setting.toLowerCase() === 'settings') {
            navigate('/settings');
        }
    };

    const navBtnSx = (path: string) => ({
        color: location.pathname === path ? colors.greenAccent[400] : 'white',
        display: 'block',
    });

    return <>
        <Box display="flex" justifyContent="space-between" p={1} sx={{ backgroundColor: `${colors.primary[500]}` }}>
            <Box display="flex">
                <Typography variant="h6" noWrap component="div">
                    <img src='/logo.png' alt={"RevOptica"} height="40px" width="140px" />
                </Typography>
                <Box display="flex" justifyContent="center" gap={1}>
                    <Button sx={navBtnSx('/home')} onClick={() => navigate('/home')}>
                        Home
                    </Button>
                    <Button sx={navBtnSx('/insights')} onClick={() => navigate('/insights')}>
                        Insights
                    </Button>
                </Box>
            </Box>
            <Box display="flex">
                <MenuButton
                    icon={SettingsIcon}
                    items={['Settings', 'Logout']}
                    onMenuItemClick={userMenuItemClicked} />
            </Box>
        </Box>
    </>
}

export default React.memo(Topbar);
